import { StatusBadgeWithDot } from '@modules/Orders/List/components/display/StatusBadgeWithDot';
import { defaultOrderStatusDot, statusColorMap } from '@modules/Orders/List/config/orderStatusConfig';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { isMobile } from 'react-device-detect';

interface BreadcrumbProps {
  orderRef?: string;
  orderStatusDescription?: string;
  orderStatusId?: number;
}

export const Breadcrumb = ({ orderRef, orderStatusDescription, orderStatusId }: BreadcrumbProps) => {
  // 🍞 Breadcrumbs para la página de ver pedidos
  const breadcrumbs = useMemo(() => {
    const items = [];
    const statusDot =
      orderStatusId && statusColorMap[orderStatusId] ? statusColorMap[orderStatusId].dot : defaultOrderStatusDot.dot;

    // Solo agregar "Pedidos" si NO es mobile
    if (!isMobile) {
      items.push({ label: 'Pedidos', path: '/orders' });
    }

    // Siempre agregar el segundo item
    items.push({
      label: (
        <div className="flex items-center gap-2">
          <span className="text-title line-clamp-1 max-w-[calc(100vw-265px)] sm:line-clamp-1 sm:max-w-[300px]">
            {orderRef || ''}
          </span>
          <StatusBadgeWithDot className="text-xs" dotClassName={statusDot} label={orderStatusDescription || ''} />
        </div>
      ),
      _key: `${orderRef ?? ''}-${orderStatusId ?? ''}-${orderStatusDescription ?? ''}`,
    });

    return items;
  }, [orderRef, orderStatusDescription, orderStatusId]);

  // 🍞 Configurar breadcrumbs
  usePageNavigation({ breadcrumbs });

  return null;
};
